import React from 'react';
import { CDBSidebar, CDBSidebarContent, CDBSidebarHeader, CDBSidebarFooter, CDBSidebarMenu, CDBSidebarMenuItem } from 'cdbreact'; import { NavLink, Link, Outlet } from 'react-router-dom';
import useAdmin from '../../hooks/useAdmin';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../../firebase.init';
import { MdOutlineAddCircleOutline } from 'react-icons/md';

const Dashboard = () => {
    const [user, loading, error] = useAuthState(auth);
    const [admin] = useAdmin(user);
    console.log(admin);
    return (

        <div style={{ display: 'flex', height: '100vh', overflow: 'scroll initial' }}>
            <CDBSidebar textColer="#fff" backgroundColor="#021B29">
                <CDBSidebarHeader prefix={<i className="fa fa-bars fa-large"></i>}>
                    <h6>Admin Dashboard</h6>
                </CDBSidebarHeader>
                <CDBSidebarContent className="sidebar-content">
                    <CDBSidebarMenu>
                        <NavLink exact to="/dashboard" activeClassName="activeClicked">
                            <CDBSidebarMenuItem icon="columns">
                                 Add Inventory
                            </CDBSidebarMenuItem>
                        </NavLink>

                        <NavLink exact to="/dashboard/makeAdmin" activeClassName="activeClicked">
                            {
                                admin &&
                                <CDBSidebarMenuItem icon="columns">
                                    Make Admin
                                </CDBSidebarMenuItem>
                            }

                        </NavLink>

                        <NavLink exact to="/dashboard/manageInventory" activeClassName="activeClicked">

                            {
                                admin &&
                                <CDBSidebarMenuItem icon="columns">
                                    Manage Inventory
                                </CDBSidebarMenuItem>
                            }

                        </NavLink>

                        <NavLink exact to="/dashboard/myItems" activeClassName="activeClicked">
                            <CDBSidebarMenuItem icon="columns">
                                My Item
                            </CDBSidebarMenuItem>
                        </NavLink>
                    </CDBSidebarMenu>
                </CDBSidebarContent>
            </CDBSidebar>
            <Outlet />
        </div>
    );
};

export default Dashboard;